import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import AppointmentsList from './AppointmentsList'

export default function Appointments() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/appointments" component={AppointmentsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}